export default {
  order_again: 'Encomendar novamente',
  error_messages: {
    product_does_not_exist: 'O produto já não está disponível',
  },
  success_messages: {
    product_added_to_card: 'Produto adicionado ao carrinho',
  },
};
